<div class="aviso-container">


<!-- Certificados Vencidos -->
<div class="alert alert-danger alert-dismissible no-bottom-margin" *ngIf="certificadosVencidos.length > 0">
    <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
    <h4><i class="icon fa fa-exclamation-triangle"></i> Certificado Digital Vencido</h4>
    <ng-container *ngIf="certificadosVencidos.length === 1">
        Seu certificado digital venceu em {{ formatarData(certificadosVencidos[0].dataHoraValidadeFinal) }}.
    </ng-container>
    <ng-container *ngIf="certificadosVencidos.length > 1">
        Você possui {{ certificadosVencidos.length }} certificados digitais vencidos.
    </ng-container>
    <br>
    <strong>Importe um novo certificado para continuar assinando digitalmente.</strong>
    <a [routerLink]="['/configuracoes/meus-certificados']" style="margin-left: 5px; color: #6e6d6d; text-decoration: none; font-weight: 500;">
        (Clique aqui para gerenciar seus certificados)
    </a>
</div>


<!-- Certificados Vencendo -->
<div class="alert alert-warning alert-dismissible alert-warning-soft no-bottom-margin"
    *ngIf="certificadosVencendo.length > 0 && certificadosVencidos.length === 0">
    <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
    <h4><i class="icon fa fas fa-clock"></i> Certificado Digital Próximo do Vencimento</h4>
    <ng-container *ngIf="certificadosVencendo.length === 1">
        Seu certificado digital vence em {{ diasParaVencer }}
        {{ diasParaVencer === 1 ? 'dia' : 'dias' }}
        ({{ formatarData(certificadosVencendo[0].dataHoraValidadeFinal) }}).
    </ng-container>
    <ng-container *ngIf="certificadosVencendo.length > 1">
        Você possui {{ certificadosVencendo.length }} certificados digitais vencendo nos próximos 30 dias.
    </ng-container>
    <br>
    <strong>Providencie a renovação para evitar interrupções na assinatura digital.</strong>
    <a [routerLink]="['/configuracoes/meus-certificados']" style="margin-left: 5px; color: #6e6d6d; text-decoration: none; font-weight: 500;">
        (Clique aqui para gerenciar seus certificados)
    </a>
</div>



</div>